export const CLICK = 'Click';
export const VIEW_MODULE = 'View Module';
export const ERROR = 'Error';

export const onSlideClickEvent = (
  eventHandler,
  props,
  isOpen = false,
  extraAttributes = {},
) => {
  const defaultAttributes = {
    'Click Type': isOpen ? 'Open' : 'Close',
    'Module Position': props.modulePosition,
    'Module Name': props.module,
  };

  const finalAttributes = Object.assign(defaultAttributes, extraAttributes);

  eventHandler('Click', finalAttributes);
};

export const onModuleView = (eventHandler, props, extraAttributes = {}) => {
  const defaultAttributes = {
    'Module Position': props.modulePosition,
    'Module Name': props.module,
  };

  const finalAttributes = Object.assign(defaultAttributes, extraAttributes);

  eventHandler('View Module', finalAttributes);
};

export const buildAttributes = (props = {}, extraAttributes = {}) => {
  return Object.assign(
    {},
    {
      'Module Position': props.modulePosition + 1,
      'Module Name': props.module,
    },
    extraAttributes,
  );
};
